export default __webpack_public_path__ + "1bb7e2ac9550052f3e1c29ce740c26f6.png";